import { inWindow } from '@/config';
import { locationHelper } from '@/api/util/location_helper';
export function enableSync(ctx) {
    if (!inWindow()) {
        return false;
    }
    if (process.env.BUILD_ISELECTRON) {
        return ctx.systemApi.isMainPage();
    }
    return ctx.systemApi.isMainPage() || locationHelper.isJumpPage();
}
export function enableEdmSync(ctx) {
    return (inWindow() &&
        ctx.systemApi.getCurrentUser() &&
        process.env.BUILD_ISEDM &&
        ctx.productApi.getABSwitchSync('edm_mail') &&
        enableSync(ctx) &&
        !window.isAccountBg);
}
